<script lang="ts">
  import FaCheck from "svelte-icons/fa/FaCheck.svelte";
  import FaWindowClose from "svelte-icons/fa/FaWindowClose.svelte";
  import { fade } from "svelte/transition";
  import Button from "./button.svelte";
  import { t } from "../translations/i18n";

  export let okHandler: () => void;
  export let cancelHandler: () => void;
</script>

<div class="modal" transition:fade={{ duration: 150 }} data-testid="modal-test">
  <div class="content">
    <slot name="content" />
  </div>
  <footer>
    <Button handler={okHandler} id="remove-container-ok">
      <FaCheck slot="icon" />
      <svelte:fragment slot="text">{$t("OK")}</svelte:fragment>
    </Button>
    <Button handler={cancelHandler} id="remove-container-cancel">
      <FaWindowClose slot="icon" />
      <svelte:fragment slot="text">{$t("Cancel")}</svelte:fragment>
    </Button>
  </footer>
</div>

<style lang="scss">
  .modal {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    z-index: 10;
    padding: 1rem 2rem;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    background-color: var(--color-tertiary);
    opacity: 0.95;
    color: var(--color-white);

    footer {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1rem 2rem;
      font-weight: bold;

      :global(button) {
        width: 10rem;
        background-color: var(--color-white);
        color: var(--color-tertiary);
      }
    }
  }
</style>
